module.exports = __webpack_public_path__ + "media/images/place_presta-9d6352b7588fa456dc248f142ece7d93.jpeg";